export default "__VITE_ASSET__B9j6HJcC__"